import { VrConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "src/components/shared/TravelersField";

export const vrConfig: VrConfig = {
  navigation: {
    tabIcon: "lob_vacation_rentals",
    tabTitleToken: "wizard.vr.tab.title.label"
  },
  lastSearch: {
    useLastSearchForSingleLOB: false,
    lastSearchKey: "lastSearchCookie",
    lobKey: "wizard-vr-pwa"
  },
  location: {
    destination: {
      inputName: "destination",
      icon: "place",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      invalidOriginSameAsDestinationKey: "",
      labelToken: "wizard.destination.label",
      typeaheadLabelToken: "wizard.vr.destination.placeholder",
      pwaDialogQueryParam: "destination-vr",
      essAdapterConfig: {
        lob: "HOTELS",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      },
      queryParams: {
        regionId: "regionId",
        latLong: "latLong"
      }
    }
  },
  date: {
    ISOSubmissionSupport: true,
    format: "yyyy-MM-dd",
    submissionFormat: "yyyy-MM-dd",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    midnightBookingOffset: 4,
    maxDaysRange: 28,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidFromDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidToDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    start: {
      labelToken: "datePicker.fromDate.label"
    },
    end: {
      labelToken: "datePicker.toDate.label"
    },
    queryParam: {
      start: "startDate",
      end: "endDate"
    },
    dialogId: "check-in-out"
  },
  travelers: {
    icon: "person",
    labelToken: "wizard.roomPicker.title",
    dialogTitleToken: "wizard.roomPicker.title",
    dialogCancelLabelToken: "wizard.roomPicker.closeButton.a11yLabel",
    childrenCaptionToken: "wizard.roomPicker.children.caption",
    infantsCaptionToken: "",
    youngestChildAgeTextToken: "wizard.roomPicker.youngestChildAge.text",
    youngestInfantAgeTextToken: "",
    invalidLessThanNTravelersMessageToken: "wizard.travelers.warning.invalidNumberOfTravelers.text",
    invalidUnattendedInfantOnLapMessageToken: "",
    minBookableTravelers: 1,
    maxBookableTravelers: 14,
    minChildAge: 0,
    maxChildAge: 17,
    minInfantAge: 0,
    maxInfantAge: 1,
    minAdultsPerRoom: 1,
    maxAdultsPerRoom: 14,
    minChildrenPerRoom: 0,
    maxChildrenPerRoom: 6,
    minInfantsPerRoom: 0,
    maxInfantsPerRoom: 0,
    maxRooms: 8,
    withRooms: true,
    withFlight: false,
    withInfants: false,
    hiddenInputType: TRAVELERS_HIDDEN_INPUT_TYPE.HOTEL_SEARCH
  },
  form: {
    action: "/Hotel-Search",
    submitButton: {
      locToken: "wizard.submit.label"
    }
  },
  heading: {
    fixedTitle: false,
    lobSubtitleBreakPoint: "on",
    locToken: "wizard.mobile.label.vr"
  },
  elementId: "wizard-vr-pwa"
};
